<template>
    <div class="feedback-box">
        <div class="feedback-btn" @click="onClick" v-if="!isShow">
            <i class="el-icon-chat-dot-round" style="font-size: 20px"></i>
            FeedBack
        </div>
        <div v-if="isShow" class="feedback-content">
            <div class="title">
                FeedBack
            </div>
            <i class="el-icon-close close" @click="onClose" style="cursor: pointer;"></i>
            <div style="text-align: justify;" class="mt-2">
                If you encounter any issue regarding PDBbind+ or have suggestion, 
                you are welcome to leave your message below and send it to us. 
                Your feedback is extremely valuable for us to develop PDBbind+ into a better community resource.
            </div>
            <div class="d-flex align-center mt-2">
                <div class="desc">Your contact <br> E-mail</div>
                <el-input class="ml-1" size="small" style="width: 90%;" v-model="params.account" />
            </div>
            <div class="d-flex align-center mt-2">
                <div class="desc">Subject</div>
                <el-input class="ml-1" size="small" style="width: 90%;" v-model="params.subject" />
            </div>
            <div class="d-flex align-center mt-2">
                <div class="desc">Description</div>
                <el-input class="ml-1" size="small" type="textarea" style="width: 90%;" :rows="3" v-model="params.contents" />
            </div>
            <div class="d-flex align-center mt-2">
                    <div class="desc">Security Code:</div>
                    <el-input size="small" class="ml-1" style="width: 140px" v-model="captcha"></el-input>
                    <img class="capt-image ml-1" :src="captImage" />
                    <el-button class="refresh-btn ml-1" size="small" @click="getCaptcha">Refresh</el-button>
            </div>
            <div class="mt-2">
                <div class="desc"></div>
                <div class="d-flex space-between ml-1" style="width: 100%;margin: auto">
                    <el-button class="cl-btn" size="small" @click="onClear">Clear</el-button>
                    <el-button class="sd-btn" type="primary" style="background: #0275BE" size="small" @click="onSubmit">Send</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
/** api */
import { feedback } from '@/assets/api/brower'
import { getCaptcha } from '@/assets/api/user'
import { clearObj } from '@/assets/utils/index'

export default {
    data: () => ({
        isShow: false,
        params: {
            account: '',
            subject: '',
            contents: '',
            key: ''
        },
        captcha: '',
        captImage: null
    }),
    created() {
        this.getCaptcha()
    },
    methods: {
        onClick() {
            this.isShow = !this.isShow
        },
        onClose () {
            this.isShow = false
            this.params = clearObj(this.params)
            this.captcha = ''
            this.captImage = null
        },
        onClear() {
            this.params = {
                account: '',
                subject: '',
                contents: ''
            }
        },
        onSubmit() {
            let params = Object.assign({}, this.params)
            if (params.account == '') {
                this.$message.error('please input account!')
                return
            }
            if (params.subject == '') {
                this.$message.error('please input subject!')
                return
            }
            if (this.captcha == '') {
                this.$message.error('please input Security code!')
                return
            }
            params.captcha = this.captcha
            this.$loading()
            feedback(params).then(res => {
                this.$loading().close()
                if (res.code === 0) {
                    // 提交成功
                    this.$message.success('Submitted successful!');
                    this.params = clearObj(this.params);
                    this.captcha = '';
                    this.onClose()
                } else if (res.code === 10017) {
                // 验证码错误
                    this.$message.error('Verification code is incorrect!');
                    this.getCaptcha(); // 重新获取验证码
                } else {
                    // 其他错误
                    this.$message.error(res.msg || 'An error occurred while submitting the form!');
                }
            })
        },
        // 获取验证码
        getCaptcha() {
            getCaptcha().then(res => {
                this.params.key = res.data.key
                this.captImage = res.data.img
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.feedback-box {
    position: fixed;
    right: 20px;
    bottom: 20px;
    z-index: 99991;
}
.feedback-btn {
    position: absolute;
    bottom: 0px;
    right: 0;
    width: 140px;
    height: 50px;
    border-radius: 10px;
    background: #0275BE;
    color: white;
    font-size: 16px;
    line-height: 55px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: all 0.5s ease;
    
    &:hover {
        background: #4da5dbf0;
        text-shadow: 
            0 0 2px rgba(0, 0, 0, 0.2),
            0 0 4px rgba(255, 255, 255, 0.3);
            
        &::after {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(
                90deg,
                transparent 0%,
                rgba(255, 255, 255, 0) 30%,
                rgba(255, 255, 255, 0.1) 37%,
                rgba(255, 255, 255, 0.2) 40%,
                rgba(255, 255, 255, 0.1) 43%,
                rgba(255, 255, 255, 0) 50%,
                transparent 10%
            );
            animation: feedbackShine 3.5s cubic-bezier(0.4, 0, 0.2, 1) infinite;
        }
    }
}

@keyframes feedbackShine {
    0% {
        left: -100%;
    }
    100% {
        left: 100%;
    }
}

.feedback-content {
    width: 420px;
    height: auto;
    background: white;
    box-shadow: 2px 2px 10px 4px rgba(22, 75, 100, 0.2);
    padding: 20px 30px;
    box-sizing: border-box;
    color: #10445C;
}

.title {
    font-size: 18px;
    color: #1F324F;
    text-align: center;
}

.close {
    font-size: 21px;
    position: absolute;
    right: 20px;
    top: 20px;
    color: rgba(22, 75, 100, 1);
}

.capt-image {
    width: 60px;
    height: 32px;
}

.desc {
    width: 90px;
}
.cl-btn {
    margin-left:87px;
    width:75px;
}
.sd-btn {
    width:75px;
}
.sd-btn:hover {
    box-shadow: 0 0px 5px rgba(0, 0, 0, 0.4);
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}
</style>